module.exports = __webpack_public_path__ + "static/media/2.878fdd7c.jpg";